import { render, staticRenderFns } from "./APasswordlessOptions.vue?vue&type=template&id=17be3a70&"
import script from "./APasswordlessOptions.vue?vue&type=script&lang=js&"
export * from "./APasswordlessOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports